angular.module 'zc.projects'

.directive 'zcCampaignIncentiveList', ->
  restrict: 'E'
  scope:
    project: '='
    campaign: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_list.html'

  link: (scope, element, attrs) ->

    scope.haveActiveIncentive = (campaign) ->
      for incentive in campaign.incentives
        return true if incentive.current_status is 'active'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_incentive_list.js.coffee